// extracted by mini-css-extract-plugin
module.exports = {"buttonDanger":"ButtonDanger_buttonDanger__2-xZk"};